import { contentTypes } from 'ggApp/modules/contentful/models/contentTypes';
import { mapCfEntityToCfDiscountBanner } from './mapper';

export class CfDiscountBanner {
    static pageName = 'discountMessageBar';

    static get config() {
        return {
            contentType: contentTypes.CfDiscountBanner,
            isOptional: true,
            filters: {},
        };
    }

    static mapCfEntry = mapCfEntityToCfDiscountBanner;

    constructor(props = {}) {
        const {
            versionA,
            versionACopyableText,
            versionB,
            versionBCopyableText,
            versionC,
            versionCCopyableText,
            uniqueBrandContent,
            uniqueStoreContent,
        } = props;
        this.data = {
            versionA,
            versionACopyableText,
            versionB,
            versionBCopyableText,
            versionC,
            versionCCopyableText,
            uniqueBrandContent,
            uniqueStoreContent,
        };
    }
}
